import { render, staticRenderFns } from "./Ebixa.vue?vue&type=template&id=e72c7e92&scoped=true"
import script from "./Ebixa.vue?vue&type=script&lang=js"
export * from "./Ebixa.vue?vue&type=script&lang=js"
import style0 from "./Ebixa.vue?vue&type=style&index=0&id=e72c7e92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72c7e92",
  null
  
)

export default component.exports